import styled from 'styled-components';

import Button, { TButtonProps } from '@r1-frontend/ui-react/components/buttons/button';

import GosuslugiIcon from '../../../../assets/img/icons/logo/gosuslugi.svg';

/**
 * Кнопка с логотипом Госуслуг
 */
const GosuslugiButton = ({ children, size = 'small', onClick }: Omit<TButtonProps, 'bType' | 'Icon'>) => {
    return (
        <Button
            bType='white'
            size={size}
            Icon={<img width={20} height={20} src={GosuslugiIcon} alt='госуслуги'/>}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};

export default styled(GosuslugiButton)`
    color: #0D4CD3;
    border: 1px solid #0D4CD3;
`;
